module.exports = __webpack_public_path__ + "static/img/shezhi_xiaoxi.34cd680d.png";